import api from "@/store/api";
import {publicPath, functions} from "@/main";

const emptyState = () => {
    return {
        slides: [],
        salesPerson: null,
        intermediary: null,
        loading: false,
        loadingContact: false,
    }
}

export default {
    namespaced: true,
    state: emptyState(),
    getters: {},
    actions: {
        slider(store: any) {
            store.commit('setLoading', true);
            api.get('content/slider').then(data => {
                store.commit('setSlides', data.data);
                store.commit('setLoading', false);
            }).catch(error => {
                store.commit('setSlides', []);
            });
        },
        salesPerson(store: any) {
            // store.commit('setLoadingContact', true);
            // api.get('content/sales-person').then(data => {
            //     store.commit('setLoadingContact', false);
            //     store.commit('setSalesPerson', {...data.data, globalContact: false});
            // }).catch(error => {
                store.commit('setSalesPerson', {
                    globalContact: true,
                    fullName: 'Skupina HABERL',
                    email: functions.__getCompanyText('base_email'),
                    phone: functions.__getCompanyText('company_phone'),
                    image: publicPath + 'images/logo.svg',
                });
            // });
        },
        intermediary(store: any) {
            // store.commit('setLoadingContact', true);
            // api.get('content/sales-person').then(data => {
            //     store.commit('setLoadingContact', false);
            //     store.commit('setSalesPerson', {...data.data, globalContact: false});
            // }).catch(error => {
                store.commit('setIntermediary', {
                    globalContact: true,
                    name: 'Consortium s. r. o.',
                    id: '46 050 582',
                    address: 'Trnavská cesta 74/a, 821 02 Bratislava',
                    email: functions.__getCompanyText('base_email'),
                    phone: functions.__getCompanyText('company_phone'),
                    // image: publicPath + 'images/logo.svg',
                });
            // });
        },
    },
    mutations: {
        setSlides(state: any, data: any) {
            state.slides = data;
        },
        setSalesPerson(state: any, data: any) {
            state.salesPerson = data;
        },
        setIntermediary(state: any, data: any) {
            state.intermediary = data;
        },
        setLoading(state: any, loading: boolean = false) {
            state.loading = loading;
        },
        setLoadingContact(state: any, loading: boolean = false) {
            state.loadingContact = loading;
        },
        reset (state: any) {
            Object.assign(state, emptyState());
        }
    }
};
